module.exports = __webpack_public_path__ + "img/24.62abf1ed.png";